import { Story as InkStory } from 'inkjs/engine/Story';
import { bindExternalFunction } from '../../../ink/externalFunctions';
import { badgesClientState, toggleBadge } from '../state';
import { ary1, ary2, void2 } from '../../../types/utils';

export const bindExternalBadgesFunctions = (story: InkStory): void => {
  bindExternalFunction(story, 'has_badge', ary1(badgesClientState.isActive), 1, true);
  bindExternalFunction(story, 'toggle_badge', ary2(void2(toggleBadge)), 2, false);
};
